export default "__VITE_ASSET__BSoVEjuJ__"